const accessLevelsNumeric: {[key: string]: number} = {
    "viewerSelf": 300,
    "leader": 400,
    "manager": 500
};

export type SchoolAccessLevel = "viewerSelf" | "leader" | "manager";

export const schoolAccessLevelIsAtLeast = (first: SchoolAccessLevel,second: SchoolAccessLevel) =>
{
    return accessLevelsNumeric[first] >= accessLevelsNumeric[second];
}


export default interface SchoolAccessRecord {
    [key: string] : string | undefined;
    
    userOid?: string;
    tenantId?: string;
    schoolCode?: string;
    level?: SchoolAccessLevel
}